import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {User, ListUsersResponse} from "../../../generated/protocol";
import {AdminEntityService} from "./AdminEntityService";
import {injectable} from "inversify";

export const USER_SERVICE_NAME = "userService";

export interface UserService extends AdminEntityService<User> {

    mutePlayer(userId: number): Promise<User>;

    unMutePlayer(userId: number): Promise<User>;

    addAttribute(userId: number, key: string, value: string): Promise<any>;

    removeAttribute(userId: number, key: string): Promise<any>;

    getPlayersWithAttribute(key: string): Promise<any>;
}

@injectable()
export class UserServiceImpl extends AbstractAdminEntityService<User, ListUsersResponse> implements UserService {
    mutePlayer(userId: number): Promise<User> {
        return this.http.doPost<{}, User>(this.entityPath + "/mute/" + userId + "/true", {});
    }

    unMutePlayer(userId: number): Promise<User> {
        return this.http.doPost<{}, User>(this.entityPath + "/mute/" + userId + "/false", {});
    }

    addAttribute(userId: number, key: string, value: string) {
        return this.http.doPost<{}, User>(this.entityPath + "/attribute/" + userId + "/" + encodeURIComponent(key) + "/" + encodeURIComponent(value), {});
    }

    removeAttribute(userId: number, key: string) {
        return this.http.doDelete(this.entityPath + "/attribute/" + userId + "/" + encodeURIComponent(key) + "/");
    }

    getPlayersWithAttribute(key: string) {
        return this.http.doGet(this.entityPath + "/attributes/" + encodeURIComponent(key) + "/");
    }

    constructor() {
        super("/user");
    }

}



// WEBPACK FOOTER //
// ./src/app/service/admin/UserService.ts